/** @jsxImportSource @emotion/react */
// eslint-disable-next-line no-unused-vars
import log from "cslog";
import React, { useEffect } from "react";
import { css } from '@emotion/react'
import { decodeStyle, getHTMLContent, parseStyle, SlateViewer, useAutoFitNew } from "../../../junctionAbs";
import ElementWrapper from "./wrappers/ElementWrapper";

function HtmlText({ id, db, gs, dydb, ctx }) {
	const data = db[id];

	const [is_mounted, setIsMounted] = React.useState(false);

	const ps = parseStyle(data, gs, data.cstate);

	let input = ps.input;

	let styles_decoded = decodeStyle(ps.style, gs);

	const html = getHTMLContent(dydb, input.html);


	const [ran_key, setRanKey] = React.useState(0);
	let { ref, fontSize } = useAutoFitNew(
		[JSON.stringify(html), ran_key, dydb],
		input.autofitText?.enable,
		input.autofitText?.params?.min,
		input.autofitText?.params?.max,
	);

	useEffect(() => {
		setIsMounted(true);
	}, [])



	useEffect(() => {
		if (ref.current) {
			setRanKey(ran_key + 1);
		}
	}, [ref?.current]);

	if (!input.autofitText?.enable) {
		fontSize = input.fontSize;
	}

	if (!is_mounted) {
		return <></>
	}

	return (
		<ElementWrapper id={id}>
			{/* <p>FS: {fontSize}</p> */}
			<div
				ref={ref}
				style={{
					columnWidth: "auto",
					columnCount: input.columnCount,
					...decodeStyle(ps.fixStyle, gs),
					// ...decodeStyle(ps.style, gs),
					...styles_decoded,
					// "&:hover": decodeStyle(ps.hover, gs),
					textAlign: input.textAlign,
					width: '100%',
					minHeight: '100%', // to limit inside box
					fontSize: `${fontSize}px`,
					// maxHeight: "100%"
				}}
			>
				<div
					// className={styles.fit_wrapper}
					style={{
						// border: "1px dotted purple",
						width: 'auto',
						// fontSize: `${final_fs}px`,
					}}
					css={css`
							  .qslate p,
							  .qslate ul,
							  .qslate ol,
							  .qslate blockquote {
								  line-height: ${input.lineHeight * 100}%;
								  letter-spacing: ${input.letterSpacing.value};
							  	  margin: 0 0 ${input.elementSpacing ?? 1}em 0;
				  				  color: ${styles_decoded?.colorContent || 'inherit'};
							  }
							  .qslate h1, .qslate h2, .qslate h3, .qslate h4, .qslate h5, .qslate h6 { 
								  font-family: ${styles_decoded?.fontFamilyHeadings || 'inherit'};
								  color: ${styles_decoded?.colorHeadings || 'inherit'};
							  }
			                  .qslate ul{
				                list-style-type: '${input?.bulletStyle || 'disc'}';
			                  }
							`}
				>
					<SlateViewer
						id={id}
						key={ran_key}
						input={{
							...input,
							html: html
						}}
						styles={styles_decoded}
						dydb={dydb}
					/>
				</div>
			</div>
		</ElementWrapper>
	);
}

export default HtmlText;
